import { useTimer } from "@/contexts/TimerContext";
import { SrIcon } from "@/components/ui/SrIcon";
import { Button } from "@/components/ui/button";

function formatElapsed(seconds: number): string {
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = seconds % 60;
  const pad = (n: number) => String(n).padStart(2, "0");
  return h > 0 ? `${pad(h)}:${pad(m)}:${pad(s)}` : `${pad(m)}:${pad(s)}`;
}

export default function TimerWidget() {
  const { activeTimer, elapsedSeconds, stopTimer, isRunning } = useTimer();

  if (!isRunning || !activeTimer) return null;

  return (
    <div className="inline-flex items-center gap-2.5 px-3.5 py-1.5 rounded-full border-[1.5px] border-[var(--sr-revemoerk)] bg-card animate-in fade-in slide-in-from-top-2">
      <span className="w-2 h-2 rounded-full bg-[var(--sr-red-hex)] animate-pulse" aria-hidden />
      <span className="font-mono text-[13px] font-medium tabular-nums">
        {formatElapsed(elapsedSeconds)}
      </span>
      <span className="text-[13px] font-medium truncate max-w-[220px]" title={activeTimer.projectName}>
        {activeTimer.projectName}
      </span>
      <Button
        size="sm"
        variant="ghost"
        className="h-6 w-6 p-0 text-destructive hover:bg-destructive/10"
        onClick={stopTimer}
        title="Stopp timer"
        aria-label="Stopp timer"
      >
        <SrIcon name="pause" size={12} />
      </Button>
    </div>
  );
}
